import { Component, inject, OnDestroy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { SafeArea, SystemBarsStyle } from "@capacitor-community/safe-area";
import { TranslateService } from "@ngx-translate/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { ButtonModule } from "primeng/button";
import { ToastModule } from "primeng/toast";
import { Subscription } from "rxjs";
import { AuthService } from "./core/auth/auth.service";
import { SseService } from "./core/sse/sse-service";
import { LayoutService } from "./main/layout/service/app.layout.service";
import { ConfirmDialogComponent } from "./shared/confirm-dialog/confirm-dialog.component";

@Component({
  selector: "yt-root",
  templateUrl: "./app.component.html",
  imports: [RouterOutlet, ToastModule, ConfirmDialogComponent, ButtonModule],
})
export class AppComponent implements OnDestroy {
  // TODO remove this unused variables
  topbarTheme: string;

  surfaceTheme: string;

  componentTheme: string;

  isDarkTheme: boolean;

  primaryTheme: string;

  layoutMode: string;

  inlineMenuPosition = "top";

  scale: number;

  isRTL = false;

  configUpdateSubscription: Subscription;

  private oidcSecurityService = inject(OidcSecurityService);
  private layoutService = inject(LayoutService);
  private translateService = inject(TranslateService);
  private authService = inject(AuthService);
  private sseService = inject(SseService);

  constructor() {
    this.oidcSecurityService.isAuthenticated().subscribe((isAuthenticated) => {
      if (!isAuthenticated) {
        return;
      }

      // Initialize ngx-translate with user's language
      this.translateService.addLangs(["fr", "de", "en"]);
      this.translateService.setFallbackLang("fr");
      this.oidcSecurityService.getUserData().subscribe((userData) => {
        const userLanguage = userData?.language?.toLowerCase() || "fr";
        this.translateService.use(userLanguage);
      });

      this.init();
    });
  }

  init(): void {
    console.debug("AppComponent.init()");
    this.configUpdateSubscription = this.layoutService.configUpdate$.subscribe(
      (layoutConfig) => {
        this.isDarkTheme = layoutConfig.darkTheme;
        if (this.isDarkTheme) {
          SafeArea.setSystemBarsStyle({
            style: SystemBarsStyle.Dark,
          });
        } else {
          SafeArea.setSystemBarsStyle({
            style: SystemBarsStyle.Light,
          });
        }
      },
    );

    // Delay the subscription to the sse service to avoid subscribing when app is being reloaded aggresively
    if (!this.authService.isAdmin) {
      setTimeout(() => this.sseService.startup(), 3000);
    }
  }

  ngOnDestroy(): void {
    this.configUpdateSubscription?.unsubscribe();
  }
}
